import { Env } from '../../env';
import { ApiClient } from '../../http/api_client';
import { isSoloare, SiteType } from '../../models/js_env';
import { RecentCheckedItemJsEnv } from '../../models/recent_checked_item/recent_checked_item_js_env';
import { RecentCheckedItem } from '../../models/recent_checked_item/recent_checked_item_js_env';
import { soloareApiCommonHeader } from '../repository_constant';

const SOLOARE_SUCCESS_CODE = '00000';

export class RecentCheckedItemRepository {
  async getRecentCheckedItems(siteType: SiteType, isLogin: boolean): Promise<RecentCheckedItemJsEnv> {
    if (isSoloare(siteType) && isLogin) {
      const recentCheckedItemKeys = await ApiClient.post(Env.SETTING.soloareApi.urlBase + 'buyer/web/trylion/apiSearchRecentViewItems/', { size: 33, offset: 0 });
      if (recentCheckedItemKeys.code !== SOLOARE_SUCCESS_CODE) {
        throw new Error()
      }
      const result = await ApiClient.post(Env.SETTING.userPublicApi.urlBase + 'api/attract/item/getItemDetail', createItemServiceRequest(recentCheckedItemKeys));
      const recentCheckedItems = createRecentCheckedItems(result.recentCheckedItemList);
      return new RecentCheckedItemJsEnv(siteType, isLogin, recentCheckedItems);
    }

    const result = await ApiClient.get(Env.SETTING.userPublicApi.urlBase + `api/attract/item/recentCheckedItems/?siteType=${siteType}`);
    const recentCheckedItems = createRecentCheckedItems(result.recentCheckedItemList);
    return new RecentCheckedItemJsEnv(siteType, isLogin, recentCheckedItems);
  }

  async delete(siteType: SiteType, isLogin: boolean, supplierId: string, catalogItemCode: string) {
    if (isSoloare(siteType) && isLogin) {
      const result = await ApiClient.get(Env.SETTING.soloareApi.urlBase + `buyer/view/a190/teeda.ajax?AjaxParam0=${catalogItemCode}&component=common_ajaxRecentViewItemPage&action=ajaxRecentViewDeleteSingleItem&0=${catalogItemCode}`,
      {
        'headers': {...soloareApiCommonHeader}
      });

      if (result !== null) {
        throw new Error()
      }
    }

    await ApiClient.delete(Env.SETTING.userPublicApi.urlBase + `api/attract/item/recentCheckedItemKey/?supplierId=${supplierId}&catalogItemCode=${catalogItemCode}&siteType=${siteType}`);
  }
}

const createItemServiceRequest = (recentCheckedItemKeys: any) => {
  const request: { [name: string]: []; } = {};
  const itemKeys = recentCheckedItemKeys.recentViewItems.map((it: { supId: string; ctgItemCd: string; }) => {
    const itemKey: { [name: string]: string; } = {};
    itemKey['supplierId'] = it.supId;
    itemKey['catalogItemCode'] = it.ctgItemCd;
    return itemKey;
  })
  request['itemKeyList'] = itemKeys;
  return request
}

const createRecentCheckedItems = (recentCheckedItemList: any): RecentCheckedItem[] => {
  return recentCheckedItemList.map(((it: { supplierId: string; catalogItemCode: string; imageUrl: string; itemName: string; }) =>
    new RecentCheckedItem(it.supplierId, it.catalogItemCode, it.imageUrl, it.itemName)
  ));
}
